// src/Components/customerData.js
import customer1 from '../assests/customer1.png';
import customer2 from '../assests/customer2.png';
import customer3 from '../assests/customer3.png';
import customer4 from '../assests/customer4.png';
import customer5 from '../assests/customer5.png';
import customer6 from '../assests/customer6.png';
import customer7 from '../assests/customer7.png';
import customer8 from '../assests/customer8.jpeg';

export const CustomersList = [
  { id: 1, img: customer1 },
  { id: 2, img: customer2 },
  { id: 3, img: customer3 },
  { id: 4, img: customer4 },
  { id: 5, img: customer5 },
  { id: 6, img: customer6 },
  { id: 7, img: customer7 },
  { id: 8, img: customer8 },
];